"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Premiumeditorialservices() {
  const modules = [{
    number: "01.",
    name: "LIDERANÇA EXECUTIVA",
    description: "Desenvolvemos competências de alta gestão para líderes que buscam impacto real. Nossa abordagem une visão estratégica, inteligência emocional e governança corporativa moderna.",
    deliverables: ["Mentoria individual para C-Level", "Workshop de tomada de decisão", "Desenvolvimento de cultura ágil", "Gestão de crises e reputação"],
    cta: "SABER MAIS SOBRE LIDERANÇA",
    stat: "95% DE RETENÇÃO DE TALENTOS LÍDERES",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/masterpro_executive_leadership_consulting.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/masterpro_executive_leadership_consulting.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/masterpro_executive_leadership_consulting.png-wvc-sizes",
      alt: "Executivo em ambiente corporativo moderno e minimalista"
    }
  }, {
    number: "02.",
    name: "NETWORKING ESTRATÉGICO",
    description: "Conectamos mentes brilhantes a oportunidades exclusivas. Criamos ecossistemas de influência onde o capital social se transforma em valor tangível para sua carreira e negócios.",
    deliverables: ["Acesso a clubes de negócios exclusivos", "Mapeamento de stakeholders chave", "Eventos de networking de alto nível", "Estratégias de parcerias globais"],
    cta: "EXPLORAR NOSSA REDE",
    stat: "+500 CONEXÕES DE ALTO IMPACTO",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/masterpro_strategic_networking_event.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/masterpro_strategic_networking_event.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/masterpro_strategic_networking_event.png-wvc-sizes",
      alt: "Profissionais em reunião de networking estratégico"
    }
  }, {
    number: "03.",
    name: "LONGEVIDADE PROFISSIONAL",
    description: "Orientação especializada para profissionais experientes que desejam reinventar sua trajetória. Planejamos transições de carreira, conselhos consultivos e legado executivo.",
    deliverables: ["Planejamento de transição de carreira", "Preparação para conselhos de administração", "Gestão de marca pessoal sênior", "Mentoria de sucessão e legado"],
    cta: "PLANEJAR MEU FUTURO",
    stat: "20+ ANOS DE EXPERIÊNCIA MÉDIA",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/masterpro_professional_longevity_planning.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/masterpro_professional_longevity_planning.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/masterpro_professional_longevity_planning.png-wvc-sizes",
      alt: "Profissional sênior em escritório de alto padrão"
    }
  }];
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="3508" id="premiumeditorialservices" className="bg-background text-foreground py-24 md:py-32 lg:py-40 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-[1440px] mx-auto">
        <div ref={header.ref} className={`transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-[12px] uppercase tracking-[0.2em] mb-10 md:mb-14" style={{
          color: "var(--primary)"
        }}>
            NOSSA EXPERTISE — 03 PILARES
          </p>
          <h2 className="font-default font-bold leading-[0.95] tracking-tighter text-[32px] sm:text-[64px] md:text-[84px] lg:text-[96px]">
            <span className="block">IMPULSIONANDO</span>
            <span className="block">SUA CARREIRA</span>
            <span className="block" style={{
            WebkitTextStroke: "1.5px var(--primary)",
            color: "transparent"
          }}>
              COM VISÃO
            </span>
            <span className="block">ESTRATÉGICA.</span>
          </h2>
        </div>

        <div className="mt-24 md:mt-32 lg:mt-40 flex flex-col gap-24 md:gap-32 lg:gap-36">
          {modules.map((m, i) => {
          const reveal = useRevealOnScroll<HTMLDivElement>({
            threshold: 0.15
          });
          const isReversed = i % 2 === 1;
          return <div key={i} data-index={i} ref={reveal.ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center transition-all duration-700 ease-out ${reveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
                <div className={`order-2 ${isReversed ? "lg:order-2" : "lg:order-1"}`}>
                  <div className={`font-default font-bold leading-none tracking-tighter text-[64px] md:text-[88px] lg:text-[120px] transition-transform duration-1000 ease-out ${reveal.isVisible ? "-translate-y-2" : "translate-y-4"}`} style={{
                WebkitTextStroke: "1.5px var(--primary)",
                color: "transparent"
              }}>
                    {m.number}
                  </div>

                  <h3 className="font-default font-bold leading-[0.95] tracking-tight text-foreground text-[36px] md:text-[48px] lg:text-[56px] mt-4 md:mt-6">
                    {m.name}
                  </h3>

                  <p className="font-default font-normal text-muted-foreground text-lg md:text-xl leading-relaxed mt-6 max-w-[480px]">
                    {m.description}
                  </p>

                  <ul className="mt-8 flex flex-col gap-3 max-w-[480px]">
                    {m.deliverables.map((d, di) => <li key={di} data-index={di} className="flex items-start gap-3 font-default text-base text-foreground/80">
                        <span className="inline-block mt-[10px] shrink-0 rounded-md" style={{
                    width: "5px",
                    height: "5px",
                    backgroundColor: "var(--primary)"
                  }} aria-hidden="true" />
                        <span>{d}</span>
                      </li>)}
                  </ul>

                  <div className="mt-10">
                    <Link to="https://wa.me/5511966187866" newTab>
                      <Button variant="ghost" className="px-0 h-auto py-2 font-default font-bold uppercase tracking-widest text-sm hover:bg-transparent group" style={{
                    color: "var(--primary)"
                  }}>
                        {m.cta}
                        <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1" />
                      </Button>
                    </Link>
                  </div>
                </div>

                <div className={`order-1 relative ${isReversed ? "lg:order-1" : "lg:order-2"}`}>
                  <div className="relative aspect-[3/4] w-full overflow-hidden rounded-lg" style={{
                boxShadow: "var(--shadow-4xl)"
              }}>
                    <img src={m.image.src} data-wvc-srcset={m.image.srcset} data-wvc-sizes={m.image.sizes} alt={m.image.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />

                    <div className="absolute left-6 right-6 bottom-6 md:left-8 md:right-auto md:bottom-8 md:max-w-[320px] backdrop-blur-md px-5 py-4 border rounded-md" style={{
                  backgroundColor: "hsla(220, 15%, 8%, 0.75)",
                  borderColor: "hsla(220, 15%, 85%, 0.2)"
                }}>
                      <p className="font-mono text-[10px] uppercase tracking-[0.2em] mb-1" style={{
                    color: "var(--primary)"
                  }}>
                        MÉTRICAS DE SUCESSO
                      </p>
                      <p className="font-default font-bold text-white text-sm md:text-base leading-snug">
                        {m.stat}
                      </p>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}